<svelte:head>
    <script src="https://accounts.google.com/gsi/client" async defer on:load={googleLoaded}></script>
</svelte:head>

<script>
        import jwt_decode from "jwt-decode";
        import { onMount } from "svelte";
        import { alert, user } from '../store.js'

let googleReady = false;
let mounted = false;    

async function handleCredentialResponse(response) {
        const responsePayload = jwt_decode(response.credential);
		console.dir(responsePayload.name)
		let tmpuser = {};
		tmpuser.name = responsePayload.given_name
		tmpuser.id = responsePayload.sub
		tmpuser.accessToken = response.credential
		tmpuser.logged_in = true;
		user.set(tmpuser)
		
        
	}

    onMount(() => {
        mounted = true;
        if (googleReady) {
            displaySignInButton()
        }
    });

    function googleLoaded() {
        googleReady = true;
        if (mounted) {
            displaySignInButton()
        }
    }

    function displaySignInButton() {
        google.accounts.id.initialize({
            client_id: "684541831384-g15hjhaf3ul7fin1mbg1c011sbuddakg.apps.googleusercontent.com",
            callback: handleCredentialResponse
        });
        google.accounts.id.renderButton(
            document.getElementById("buttonDiv"),
            { theme: "outline", size: "large" }  // customization attributes
        );
        google.accounts.id.prompt(); // also display the One Tap dialog
    }    
</script>

<div>Please Login</div>
<div id="buttonDiv"></div>